//@flow

import { Provider } from 'common/models/internal/Provider';

export type Assets = {
    termsUrl: ?string,
    largeLogoSrc: string,
    faviconSrc: string,
    smallLogoSrc: string
};

export const extractAssets = (provider: ?Provider): Assets => {
    if (!provider) {
        return {
            termsUrl: 'https://locus.sh/documents/MaraLabsTermsOfUse.pdf',
            largeLogoSrc: '/img/locus-logo-dark.png',
            // NOTE: Use only PNG on smallLogoSrc for whitelabelling Chrome Notifications
            // Chrome Notification does not support SVG
            smallLogoSrc: '/img/logo_o.png',
            faviconSrc: '/img/favicon.ico'
        };
    }

    const {
        smallLogoContent,
        largeLogoContent,
        termsAndCondtionsDocumentUrl,
        faviconContent
    } = provider.assets;
    return {
        termsUrl: termsAndCondtionsDocumentUrl,
        largeLogoSrc: `data:image/png;base64,${largeLogoContent}`,
        smallLogoSrc: `data:image/png;base64,${smallLogoContent}`,
        faviconSrc: `data:image/png;base64,${faviconContent}`
    };
};
